// import PropTypes from 'prop-types'
import React, { Component, createRef } from 'react'
import Navbar from '../components/Navbar'
import './Careers.css'
// import { BASEURL } from '../conf';
// import swal from 'sweetalert';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";


export class Careers extends Component {
  constructor(props) {
    super(props);
    this.state = {
       showFirstGrid: true,
      selectedValue: "Creativity", // Default selected value
      jobListings: [
        /* Sample json 
        {
          id: ,
          role: '',
          type: 'Full Time',
          location: 'Vishakhapatnam / Hyderabad',
          typeImage: "/assets/fulltime.png",
          locationImage: "/assets/location.png",
          city: 'Hyderabad/Vishakhapatnam',
          industry: '',
          companyprofile : '',
          jobdesc : '',
          qualification: '',
          skills: [
                           { key: 1, point: '' },
                           { key: 2, point: '' },
                           {key:3, point:''},
                           {key:4, point:''},
                           {key:5, point:''},
                           {key:6, point:''},
                           {key:7, point:''},
                           {key:8, point:''},
                           {key:9, point:''},
                           {key:10, point:''},
                           {key:11, point:''},
                           {key:12, point:''},
                           {key:13, point:''},
                           {key:14, point:''},
                           {key:15, point:''}
               ],
          responsibilities :  [
                { key: 1, point: '' },
                           { key: 2, point: '' },
                           {key:3, point:''},
                           {key:4, point:''},
                           {key:5, point:''},
                           {key:6, point:''},
                           {key:7, point:''},
                           {key:8, point:''},
                           {key:9, point:''},
                           {key:10, point:''},
                           {key:11, point:''},
                           {key:12, point:''},
                           {key:13, point:''},
                           {key:14, point:''},
                           {key:15, point:''}
                 ],
          preferable :  [
               { key: 1, point: '' },
                           { key: 2, point: '' },
                           {key:3, point:''},
                           {key:4, point:''},
                           {key:5, point:''},
                           {key:6, point:''},
                           {key:7, point:''},
                           {key:8, point:''},
                           {key:9, point:''},
                           {key:10, point:''},
                           {key:11, point:''},
                           {key:12, point:''},
                           {key:13, point:''},
                           {key:14, point:''},
                           {key:15, point:''}
                 ],
          desiredprofile :  [
                           { key: 1, point: '' },
                           { key: 2, point: '' },
                           {key:3, point:''},
                           {key:4, point:''},
                           {key:5, point:''},
                           {key:6, point:''},
                           {key:7, point:''},
                           {key:8, point:''},
                           {key:9, point:''},
                           {key:10, point:''},
                           {key:11, point:''},
                           {key:12, point:''},
                           {key:13, point:''},
                           {key:14, point:''},
                           {key:15, point:''}
                 ],
          relevantindustry : '',
          experience : '',
          compensation : '',
          joining : '',
          interviewprocess : '',
          contact : 'D. Gopal (Senior Manager-HR), (O)040-66305000, (M) 9177996628, hr@avantel.in'
          } */ 

          {
            id: 1,
            role: 'Embedded Senior Engineer',
            type: 'Full Time',
            location: 'Vishakhapatnam / Hyderabad',
            typeImage: "/assets/fulltime.png",
            locationImage: "/assets/location.png",
            city: 'Hyderabad/Vishakhapatnam',
            industry: 'Electronics Design / R & D',
            companyprofile : 'AVANTEL LIMITED is a technology driven public limited company with focus on developing innovative wireless communication products and solutions to meet unique requirements of defense, railways, and telecom sectors.  The organization is certified against AS 9100D and ISO 9001:2015 standards for Quality Management System. For more details visit www.avantel.in.',
            qualification: 'BE/B.Tech (ECE), M.Sc. (Electronics)',
            skills: [
                { key: 1, point: 'Coding and Debugging in C language' },
                     { key: 2, point: 'Knowledge on ARM based architectures of 8/16/32 Microcontrollers, UART, ADC, DAC, Ethernet, SPI, CAN, I2C and I2S.' }
                 ],
            responsibilities :  [
              { key: 1, point: 'Coding and Debugging in C language' },
                   { key: 2, point: 'Knowledge on ARM based architectures of 8/16/32 Microcontrollers, UART, ADC, DAC, Ethernet, SPI, CAN, I2C and I2S.' }
               ],
            preferable :  [
              { key: 1, point: 'FPGA RTL coding and Simulation using Verilog/VHDL' },
               ],
            relevantindustry : 'Only Defense and Aerospace, Electronics, Semi-Conductors, (No Automative industry)',
            experience : '5 to 10 years',
            compensation : '6 to 12 LPA',
            joining : 'Immediate',
            interviewprocess : 'Virtual',
            contact : 'D. Gopal (Senior Manager-HR), (O)040-66305000, (M) 9177996628, hr@avantel.in'
            },
            {
              id: 2,
              role: 'Design Engineer - Parabolic & Earth Station Antennas',
              type: 'Full Time',
              location: 'Vishakhapatnam / Hyderabad',
              typeImage: "/assets/fulltime.png",
              locationImage: "/assets/location.png",
              city: 'Hyderabad/Vishakhapatnam',
              industry: 'Electronics Design / R & D',
              jobdesc : 'We are looking for an experienced Design Engineer with strong expertise in design and development for parabolic and earth station antenna (3.8m / 6.3m / 7.5m / 9.3m / 11m) applications. The role involves the design, simulation, and validation of electronic subsystems used in large antenna systems for satellite communication.',
              qualification: '',
              skills: [
                  { key: 1, point: 'Strong knowledge of RF/microwave theory, antenna fundamentals, and satellite communication systems.' },
                       { key: 2, point: 'Experience in RF simulation tools (HFSS, ADS, CST, FEKO, or similar).' },
                       { key: 3, point: 'Hands-on experience in RF measurements using network analyzers, spectrum analyzers, and power meters.' },
                       {key: 4, point: 'Knowledge of C, Ku, and Ka band systems and associated RF hardware.'},
                       {key: 5, point: 'Familiarity with servo control systems, tracking electronics, and telemetry interfaces is an added advantage.'},
                       {key: 6, point: 'Good analytical and troubleshooting skills in RF/electronic systems.'},
                   ],
              responsibilities :  [
                    { key: 1, point: 'Design and development of RF and parabolic and earth station antenna (3.8m / 6.3m / 7.5m / 9.3m / 11m) applications.' },
                         { key: 2, point: 'Work on LNA, BUC, waveguide, filter, and power amplifier integration for antenna systems.' },
                         { key: 3, point: 'Perform RF simulations and analysis for antenna performance optimization.' },
                         { key: 4, point: 'Involve in system-level design, link budget analysis, and interface with baseband and control electronics.' },
                         { key: 5, point: 'Support testing, calibration, and validation of electronic subsystems.' },
                         { key: 6, point: 'Collaborate with mechanical and systems teams for complete antenna integration.' },
                         { key: 7, point: 'Prepare technical documents including schematics, BOMs, test reports, and design documentation.' },

                     ],
              preferable :  [
                    { key: 1, point: 'Experience in Earth Station or Satellite Ground Systems.' },
                         { key: 2, point: 'Exposure to Defence or Aerospace communication projects.' },
                         { key: 3, point: 'Understanding of system integration and environmental testing.' }
                     ],
             
              experience : '5 - 10 Years',
             
              },
              {
                id: 3,
                role: 'PCB Designer Engineer',
                type: 'Full Time',
                location: 'Hyderabad',
                typeImage: "/assets/fulltime.png",
                locationImage: "/assets/location.png",
                city: 'Hyderabad',
                companyprofile : 'AVANTEL LIMITED is a technology driven public limited company with focus on developing innovative wireless communication products and solutions to meet unique requirements of defense, railways, and telecom sectors.  The organization is certified against AS 9100D and ISO 9001:2015 standards for Quality Management System. For more details visit www.avantel.in.',
                qualification: 'B.Tech / Diploma (ECE / EIE / EEE)',
                skills: [
                    { key: 1, point: 'Hands on experience in Pcb Design with tools : Cadstar( Zuken), Pads professional & CAM' },
                         { key: 2, point: 'Multilayer Pcb design( 2 layer and above)' },
                         { key: 3, point: 'Understanding of electronic components and its footprints' },
                         { key: 4, point: 'Knowledge in Design Stack up and Impedance control for high speed circuits.' },
                         { key: 5, point: 'Knowledge in Schematic Design and understanding.' },
                         { key: 6, point: 'Knowledge on signal integrity is desirable.' },
                         { key: 7, point: 'Knowledge on DFM-DFT' }
                     ],
                experience : '2 to 4 years',
                contact : 'D. Gopal (Senior Manager-HR), (O)040-66305000, (M) 9177996628, hr@avantel.in'
                },
                {
                  id: 4,
                  role: 'Quality Management System',
                  type: 'Full Time',
                  location: 'E-City, Tukkuguda, Hyderabad',
                  typeImage: "/assets/fulltime.png",
                  locationImage: "/assets/location.png",
                  city: 'Hyderabad',
                  industry: 'Defence, Electronics Manufacturing and Satellite communication',
                  companyprofile : 'AVANTEL LIMITED is a technology driven public limited company with focus on developing innovative wireless communication products and solutions to meet unique requirements of defense, railways, and telecom sectors.  The organization is certified against AS 9100D and ISO 9001:2015 standards for Quality Management System. For more details visit www.avantel.in.',
                  qualification: 'B.Tech (ECE) / M.Sc (Electronics)',
                  skills: [
                      { key: 1, point: 'Minimum 5 years of experience in electronics manufacturing, with strong preference for candidates from the aerospace and defence electronics sector.' },
                           { key: 2, point: 'At least 3-5 years hands-on experience implementing ISO 9001 and AS9100 standards in a manufacturing environment.' },
                           {key:3, point:'Proven ability in developing, reviewing, and maintaining AS9100 procedures, as well as quality documentation such as QAP, ATP, QTP, FAT, and CBD.'},
                           {key:4, point:'Familiarity with implementation and compliance procedures for AS9115, AS9102, and AS9103.'},
                           {key:5, point:'Sound understanding of regulatory frameworks and industry requirements pertinent to the aerospace and defence sector.'},
                           {key:6, point:'Exposure to and working knowledge of key industry standards, including IPC/J-STD, JSS 55555:2012, MIL-461 E/F, MIL-810 G, ESD S20:20, DO-160, DO-178, and DO-254.'},
                           {key:7, point:'Experience in supplier and vendor development, including conducting comprehensive supplier evaluation and audit processes.'},
                           {key:8, point:'Hands-on experience in defining, measuring, and monitoring process KPIs, capability, and key characteristics using statistical process controls (SPC), including Cp, Cpk, and control charts.'},
                           {key:9, point:'In-depth experience with FOD control, 5S workplace organization, and quality improvement methodologies such as CAPA, RCCA, and FMEA.'},
                           {key:10, point:'Practical experience in conducting special process validations and process audits as part of ongoing quality initiatives.'},
                           {key:11, point:'Ability to interact effectively with external regulatory and quality agencies such as DGQA, CQAE(N), CEMILAC, DGAQA, DGNAI, MSQAA, and RDSO/Railways (optional but preferred).'},
                           {key:12, point:'Strong communication, presentation, and client management skills.'},
                           {key:13, point:'Proficiency in using MS Office, MS Project, and ERP systems for quality documentation and project management.'},
                           {key:14, point:'Capable of developing and delivering effective training sessions for technical and non-technical staff.'},

                       ],
                  
                  relevantindustry : 'Defence, Electronics Manufacturing and Satellite communication',
                  experience : 'Min 5 years',
                  compensation : 'As per industry standards',
                  contact : 'Praveen Reddy K, (M) 8639206429, praveenreddy.k@avantel.in'
                  },
                  {
                    id: 5,
                    role: 'RF Manager / Senior Manager',
                    type: 'Full Time',
                    location: 'Vishakhapatnam',
                    typeImage: "/assets/fulltime.png",
                    locationImage: "/assets/location.png",
                    city: 'Vishakhapatnam',
                    industry: 'Electronics /Telecommunications',
                    companyprofile : 'AVANTEL LIMITED is a technology driven public limited company with focus on developing innovative wireless communication products and solutions to meet unique requirements of defense, railways, and telecom sectors.  The organization is certified against AS 9100D and ISO 9001:2015 standards for Quality Management System. For more details visit www.avantel.in.',
                    qualification: 'B.Tech / M.Tech (Electronics)',
                    skills: [
                      { key: 1, point: 'Strong RF skills, design, testing and evaluation in the area of wireless communication systems in Satcom and terrestrial communication' },
                      { key: 2, point: 'Good knowledge and design skills on RF front-end, filters, diplexers, directional couplers, Up/down converters, SSPAs and antennas' },
                      {key:3, point:'Good knowledge on RF design/simulation tools like ADS/EMDS/ESOFF/MW office etc.'},
                      {key:4, point:'Understanding of thermal design and EMI/EMC design and testing.'},
                      {key:5, point:'He must manage the life cycle of the project right from specifications to end product.'},
                      {key:6, point:'Hardware & software understanding of communication systems, design, testing and implementation.'},
                      {key:7, point:'Knowledge on MIL-STD-810/JSS 55555/MIL 704'},
                      {key:8, point:'Hands on experience on RF Simulation tools like ADS/ CST Studio'},
                      {key:9, point:'Knowledge on documentation as per defense requirements.'}
                         ],
                    relevantindustry : 'Electronics /Telecommunications',
                    experience : '8 to 12 years',
                    compensation : '12 to 18 LPA',
                    contact : 'D. Gopal (Senior Manager-HR), (O)040-66305000, (M) 9177996628, gopal@avantel.in'
                    },
                    {
                      id: 6,
                      role: 'Project Manager',
                      type: 'Full Time',
                      location: 'Hyderabad (Tukkuguda) - Near E-City (FAB CITY)',
                      typeImage: "/assets/fulltime.png",
                      locationImage: "/assets/location.png",
                      city: 'Hyderabad',
                      industry: 'Telecom / SATCOM',
                      companyprofile : 'AVANTEL LIMITED is a technology driven public limited company with focus on developing innovative wireless communication products and solutions to meet unique requirements of defense, railways, and telecom sectors.  The organization is certified against AS 9100D and ISO 9001:2015 standards for Quality Management System. For more details visit www.avantel.in.',
                      qualification: 'MSC/MCA/BTech/MTech',
                      skills: [
                        { key: 1, point: 'Strong knowledge in Java' },
                        { key: 2, point: 'Excellent knowledge in Protocol development' },
                        {key:3, point:'Very good knowledge in IP'},
                        {key:4, point:'Knowledge in Databases, MS SQL and My SQL'},
                        {key:5, point:'Knowledge in Networking concepts'},
                        {key:6, point:'Knowledge in application fine tuning'},
                        {key:7, point:'Knowledge in Spring Framework and Front end technologies'},
                        {key:8, point:'Knowledge in Enterprise application development and deployment'},
                       
                           ],
                      responsibilities :  [
                        { key: 1, point: 'Preparation of technical proposals and documents' },
                        { key: 2, point: 'Good knowledge in development of Enterprise applications, defining architecture' },
                        {key:3, point:'Good understanding in project management and agile methodology'},
                        {key:4, point:'Planning the software projects, including defining the scope, allocating resources,  setting deadlines, laying out communication strategies, and indicating tests'},
                        {key:5, point:'Assembling and leading the project team.'},
                        {key:6, point:'Participating in and supervising each stage of the project.'},
                        {key:7, point:'Ensuring the project stays on schedule and adheres to the deadlines.'},
                        {key:8, point:'Tracking milestones, deliverables, and change requests.'},
                        {key:9, point:'Proven experience in project management and software development'},
                        {key:10, point:'Good working knowledge of project estimation techniques.'},
                        {key:11, point:'Good leadership, decision-making, and organization skills'},
                             ],
                      experience : '10 to 20 years',
                      contact : 'D. Gopal (Senior Manager-HR), (O)040-66305000, (M) 9177996628, gopal@avantel.in'
                      },             
      ],
      filteredJobListing: []
    };
  }
  // const { HyderabadJobs, selected_job, selectedFileName } = this.state;
  componentDidMount() {
    // Initialize filteredItems with the original array
    this.setState({ filteredJobListing: this.state.jobListings });
  }
  // filteredJobListing=this.jobListings


  handleValueClick = (event, value) => {
    this.setState({ selectedValue: value });
  };
  handleSearch = (event) => {
    const searchValue = event.target.value.toLowerCase(); // Get input value and convert to lowercase
    const filteredJobListing = this.state.jobListings.filter((obj) =>
      obj.role.toLowerCase().includes(searchValue) // Check if role includes the search value
    );
    this.setState({ filteredJobListing });
  };


  handledropdownClick = (value) => {
    console.log('value', value.target.value)
    const filteredJobListing = this.state.jobListings.filter((obj) => obj.department.toLowerCase() == value.target.value.toLowerCase())
    console.log('filtered', this.filteredJobListing)
    this.setState({ filteredJobListing });
  }
  handledropCityClick = (event) => {
    const value = event.target.value; // Selected value from dropdown

    // Filter job listings based on city
    const filteredJobListing = this.state.jobListings.filter((obj) => {
      const cities = obj.location?.split('/');
      return cities && cities.some((city) => city.trim().toLowerCase().includes(value.trim().toLowerCase()));
    });


    this.setState({ filteredJobListing });
  };

  renderContent = () => {
    const { selectedValue } = this.state;

    // Map content to each value
    const contentMap = {
      Creativity: {
        image: "/assets/creativity.png",
        title: "Creativity",
        description:
          "As a leader in technology, Avantel Limited is at the forefront of innovation. Our R&D department encourages breakthrough ideas to stay ahead of the curve and push the boundaries of what’s possible.",
      },
      Synergy: {
        image: "/assets/synergy.png",
        title: "Synergy",
        description:
          "Synergy is the heart of teamwork. At Avantel, we foster collaboration and mutual respect to achieve greater goals together.",
      },
      Dedication: {
        image: "/assets/dedication.png",
        title: "Dedication",
        description:
          "Our dedication to excellence drives us to deliver the highest quality products and services to our customers.",
      },
      Dignity: {
        image: "/assets/dignity.png",
        title: "Dignity",
        description:
          "Avantel values fairness and inclusivity, ensuring equal opportunities for everyone within our organization.",
      },
      Unity: {
        image: "/assets/unity.png",
        title: "Unity",
        description:
          "Unity empowers us to face challenges together, creating a culture of strength and shared success.",
      },
    };

    // Fallback content if no valid value is selected
    const fallbackContent = {
      image: "/assets/default.png",
      title: "Default Value",
      description: "Select a value to view its details.",
    };

    // Get content for selected value, fallback if undefined
    const { image, title, description } =
      contentMap[selectedValue] || fallbackContent;

    return (
      <div className="value-content">
        <img src={image} width="30%" alt={title} className="image" />
        <div>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    );
  };


  handleLeftClick = () => {
    this.setState({ showFirstGrid: true });
  };

  handleRightClick = () => {
    this.setState({ showFirstGrid: false });
  };

  render() {
const { showFirstGrid } = this.state;
    const testimonials = [
      {
        quote: "It’s been a privilege to be part of the Avantel family for 15 years. The company’s employee-friendly culture, strong leadership, and engineering excellence have fueled over 15x growth and earned trust across defense, railways, and fisheries sectors. With a focus on innovation and customer support, Avantel continues to lead in satellite communication and indigenous manufacturing.",
        name: "Premnath Pandey",
        role: "Mumbai",
        image: "/assets/employee1.jpg",
      },
      {
        quote: "Since joining Avantel Limited in August 2016, I’ve had a positive and fulfilling experience in a professional and value-driven environment. I appreciate the growth opportunities and the strong support from both management and colleagues. With continued focus on development and open communication, Avantel will remain a great place to work.",
        name: "Ravi Shanker Jawa",
        role: "New Delhi",
        image: "/assets/employee2.jpeg",
      },
      {
        quote: "Working at Avantel has truly been a dream come true. The leadership is inspiring, guided by strong values and a clear vision, and the collaborative work culture ensures that ideas are genuinely heard and valued. The exposure and hands-on experience across various domains have been enriching and uncommon in larger organizations. It's been a rewarding journey, and I look forward to building a meaningful and successful career here.",
        name: "Vanshika M",
        role: "Hyderabad",
        image: "/assets/employee3.jpeg",
      },
    ];

    // const scrollingContent = [...testimonials, ...testimonials];

    return (
      <div>
        <Navbar page="careers" />
        <main className="mainContentCareer">
          {/* Main Banner Section */}
          <div className="bannerCareer">
            {/* <img src="assets/career_image.png" width={"100%"} alt="homescreen" />*/}
            <div className='bannerText'>
              <div className='bannerHeading'>Explore Exciting Career</div>
              <div className='bannerSubHeading'> Opportunities with Us</div>
            </div>
          </div>

          {/* Avantel Commitment Section */}
          <div className="commitment">
            <h2 className='commitment-heading'>Avantel Commitment</h2>
            <p>
              At Avantel Limited, we are committed to innovation, excellence, and
              the continuous development of our people. We offer a dynamic work
              environment where creativity and collaboration are encouraged. As a
              part of our team, you will have the opportunity to work on cutting-edge
              technologies and contribute to projects that make a significant
              impact on industries, society, and the world. Learn from the best, be
              part of a company that values your contributions, and invest in your
              future.
            </p>
          </div>
          {/* <span className="borderline"></span> */}

          {/* Core Values Section */}
          <div className="core-values">
            <h2>Avantel Core Values</h2>
            <div className="values-list">
              {["Creativity", "Synergy", "Dedication", "Dignity", "Unity"].map(
                (value) => (
                  <span
                    key={value}
                    className={`value-text ${this.state.selectedValue === value ? "active" : ""
                      }`}
                    onClick={(event) => this.handleValueClick(event, value)}
                  >
                    {value}
                  </span>
                )
              )}
            </div>

            {/* Render content dynamically based on selected value */}
            {this.renderContent()}
          </div>
          {/* <span className="borderline2"></span> */}

          {/* <div className="testimonials">
            <h2>Testimonials</h2>
            <div className="testimonial-container">
              <div className="scroll-wrapper">
                {testimonials.map((testimonial, index) => (
                  <div className='testimonial-card-main'>
                    <div className="testimonial-card" key={index}>
                      <div className="testimonial-employeecard">
                        <p className="testimonial-quote">{testimonial.quote}</p>
                      </div>
                      <div className="imagecontainer">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="testimonial-image"
                        />
                        <h4 className="testimonial-name">{testimonial.name}</h4>
                        <p className="testimonial-role">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

         <div className='container-padding'>
           <div className="testimonials">
            <h2>Testimonials</h2>
            <div className="testimonial-containr">
              <div className="scroll-wrapper-div">
                {testimonials.map((testimonial, index) => (
                  <div className='testimonial-cards-main'>
                    <div className="testimonial-cards" key={index}>
                      <img
                        src='/assets/quamas.png'
                        alt='quote'
                        style={{ width: '30px', height: '35px' }}
                      />
                      <div className="testimonial-quotes">"{testimonial.quote}"</div>
                    </div>
                    <div className="empimagecontainer">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="employee-image"
                      />
                      <h4 className="testimonial-name">{testimonial.name}</h4>
                      <p className="testimonial-role">{testimonial.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>


          {/* <span className="borderline3"></span> */}
         <div className="lifeatavantel">
        <h2 className="lifeatavantel-heading">Life At Avantel</h2>
        <p>
          Work joyfully and peacefully knowing that right thoughts and right efforts invariably bring about right result
        </p>

        {/* IMAGE GRID */}
       <div className={`${showFirstGrid ? 'first-grid' : 'second-grid'}`}>

          {showFirstGrid ? (
            <>
            <div className='images_box'>
              <div className="item1"></div>
              <div className="item2"></div>
              <div className="item3"></div>
              <div className="item4"></div>
              <div className="item5"></div>
              <div className="item6"></div>
              <div className="item7"></div>
              <div className="item8"></div>
              <div className="item9"></div>
              </div>
            </>
          ) : (
            <>
              <div className='images_box_2'>
              <div className="item10"></div>
              <div className="item11"></div>
              <div className="item12"></div>
              <div className="item13"></div>
              <div className="item14"></div>
              <div className="item15"></div>
              <div className="item16"></div>
              <div className="item18"></div>
              </div>
            </>
          )}
        </div>

        {/* PROGRESS LINE + ARROWS */}
      <div className="arrow-progress-container">
  <div className="line-arrow-wrapper">
    <button
      className="arrow-btn"
      onClick={this.handleLeftClick}
      disabled={showFirstGrid}
    >
      <FaArrowLeft />
    </button>

    <div className="line-container">
      <div className={`progress-line ${showFirstGrid ? 'left-active' : 'right-active'}`}></div>
    </div>

    <button
      className="arrow-btn"
      onClick={this.handleRightClick}
      disabled={!showFirstGrid}
    >
      <FaArrowRight />
    </button>
  </div>
</div>

      </div>

          {/* <span className="borderline4"></span> */}

          <div className='openpositions'>
            <h4 className='hiring-heading'>We're hiring</h4>
            <h2 className='openposition-heading'>Open Positions</h2>
            <div className='searchmainbox'>
              <div className='searchbar'>
                <div className='searchicon'>
                  <input
                    type="text"
                    placeholder="Search by job role"
                    className="search"
                    onChange={this.handleSearch} // Pass the event object directly
                  />
                  <select className='selectdepartment' placeholder='Select Department' onChange={(val) => this.handledropdownClick(val)}>
                    <option selected disabled={true}>Select Department</option>
                    <option value={'software'}>Software</option>
                    <option value={'r & d'}>R & D</option>
                  </select>
                  <select className='selectstate' onChange={(val) => this.handledropCityClick(val)}>
                    <option selected disabled={true}>City, State, or country/region</option>
                    <option value={'Hyderabad'}>Hyderabad</option>
                    <option value={'Vishakhapatnam'}>Vishakhapatnam</option>
                  </select>

                </div>
              </div>
            </div>
            <div className='jobslist' style={{
              justifyContent:
                this.state.filteredJobListing.length > 2 ? "space-between" : "flex-start",
            }}>
              {this.state.filteredJobListing.map((job, index) => (
                <div className='jobcard' key={index}>
                  <h3 className='jobtitle'>{job.role}</h3>
                  <div className='jobtype'>
                    <img src={job.typeImage} alt="Job Type" className='jobImage' />
                    {job.type}
                  </div>
                  <div className='joblocation'>
                    <img
                      src={job.locationImage}
                      alt="Location"
                      className='locationImages'
                    />
                    {job.location}
                  </div>
                  {/* <a href="jobdescription" className='applyNow'>
                    Apply Now →
                  </a> */}
                  <Link
                    to={{
                      pathname: "/jobdescription",
                      state: job,
                    }}
                    className="applyNow"
                  >
                    Apply Now →
                  </Link>
                </div>
              ))}

            </div>
          </div>
         </div>

        </main>
        <Footer />
      </div>

    )
  }
}

export default Careers